import { render, staticRenderFns } from "./Lista.vue?vue&type=template&id=10300daa"
import script from "./Lista.vue?vue&type=script&lang=js"
export * from "./Lista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports